import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center relative"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1770816305998-57eec25ac2d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyZSUyMHdoaXRlJTIwY2xlYW4lMjBtb2Rlcm58ZW58MHx8fHwxNzc0ODg0MTk5fDA&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-white/90 backdrop-blur-sm"></div>

      <div className="relative z-10 w-full max-w-md p-8">
        <div className="bg-white border border-slate-200 rounded-sm shadow-md p-8">
          <div className="mb-8">
            <h1 className="text-4xl font-extrabold tracking-tighter text-slate-900 mb-2">
              Accedi
            </h1>
            <p className="text-sm text-slate-600">Sistema di Gestione Accise Energetiche</p>
          </div>

          {error && (
            <div
              className="mb-6 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-sm"
              data-testid="login-error-message"
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-sm font-semibold text-slate-700">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-white border-slate-300 focus:ring-[#0066FF]/20 focus:border-[#0066FF] rounded-sm"
                placeholder="admin@energyexcise.it"
                required
                data-testid="login-email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-slate-700">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-white border-slate-300 focus:ring-[#0066FF]/20 focus:border-[#0066FF] rounded-sm"
                placeholder="••••••••"
                required
                data-testid="login-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#0A2540] hover:bg-[#0A2540]/90 text-white rounded-sm font-medium transition-all"
              data-testid="login-submit-button"
            >
              {loading ? 'Accesso in corso...' : 'Accedi'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-slate-600">
              Non hai un account?{' '}
              <Link
                to="/register"
                className="text-[#0066FF] hover:underline font-medium"
                data-testid="register-link"
              >
                Registrati
              </Link>
            </p>
          </div>
        </div>

        <div className="mt-6 text-center text-xs text-slate-500">
          <p>D.Lgs. 43/2025 - Sistema Conforme alle Normative Vigenti</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;